import { InitialInfoResponse, PortalMode } from '@next/backend-client';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_INFO = {
    PortalMode: PortalMode.KSC_CC,
    Country: {
        CountryCode: '',
    },
} as const;

const STALE_TIMEOUT = 60 * 60 * 1000;

export const useInitialInfo = (isEnabled: boolean = true) => {
    const { data = DEFAULT_INFO, isFetching } = useQuery({
        queryKey: ['init'],
        queryFn: async (): Promise<InitialInfoResponse> => {
            const response = await fetch(`${process.env.PUBLIC_URL}/init`);

            return (await response.json()) as InitialInfoResponse;
        },
        staleTime: STALE_TIMEOUT,
        placeholderData: prevData => prevData ?? DEFAULT_INFO,
        enabled: isEnabled,
    });

    return {
        isKscMode: data.PortalMode === PortalMode.KSC_CC,
        initialInfo: data,
        isFetching,
    };
};
